
	import {
		Component,
		Vue
	} from 'vue-property-decorator';

	@Component({

	})
	export default class App extends Vue {
		mounted() {
			function checkIE() {
				return '-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style
			}
			if (checkIE()) {
				window.addEventListener('hashchange', () => {
					var currentPath = window.location.hash.slice(1);
					if (this.$route.path !== currentPath) {
						this.$router.push(currentPath)
					}
				}, false)
			}
		}


	}
